import SignInView from '../../views/SignInView.vue'
import SignedInView from '../../views/SignedInView.vue'
import DevicesView from '../../views/DevicesView.vue'
import ConfigurationsView from '../../views/ConfigurationsView.vue'
import ChangeConfigurationOrderView from '../../views/ChangeConfigurationOrderView.vue'
import CreateConfigurationView from '../../views/CreateConfigurationView.vue'
import EditConfigurationView from '../../views/EditConfigurationView.vue'
import ComponentsView from '../../views/ComponentsView.vue'
import CreateComponentView from '../../views/CreateComponentView.vue'
import EditComponentView from '../../views/EditComponentView.vue'
import ConfigurationFiltersView from '../../views/ConfigurationFiltersView.vue'
import EditConfigurationFilterView from '../../views/EditConfigurationFilterView.vue'
import NotAllowed from '../../views/NotAllowedView'

const routes = [
  { 
    path: '*',
    redirect: '/signin' 
  },
  { 
    path: '/', 
    redirect: '/signin' 
  },
  { 
    path: '/signin', 
    name: 'SignInView',
    component: SignInView,
    meta: {
      requiresAuth: false
    }
  },
  { 
    path: '/token/:token', 
    name: 'Token',
    component: SignInView,
    meta: {
      requiresAuth: false
    }
  },
  { 
    path: '/notallowed', 
    name: 'NotAllowed',
    component: NotAllowed,
    meta: {
      requiresAuth: true
    }
  },
  { 
    path: '/a/devices-configurations', 
    component: SignedInView,
    meta: {
      requiresAuth: true
    },
    children: [
      { 
        path: '', 
        name: 'DevicesView',
        component: DevicesView
      },
      { 
        path: '/a/devices-configurations/:deviceId', 
        name: 'ConfigurationsView',
        component: ConfigurationsView
      },
      { 
        path: '/a/devices-configurations-order/:deviceId', 
        name: 'ChangeConfigurationOrderView',
        component: ChangeConfigurationOrderView
      },
      { 
        path: '/a/devices-configurations/:deviceId/create-configuration', 
        name: 'CreateConfigurationView',
        component: CreateConfigurationView
      },
      { 
        path: '/a/devices-configurations/:deviceId/edit-configuration/:configurationId', 
        name: 'EditConfigurationView',
        component: EditConfigurationView
      },
      { 
        path: '/a/devices-configurations/:deviceId/edit-filters', 
        name: 'ConfigurationFiltersView',
        component: ConfigurationFiltersView
      },
      { 
        path: '/a/devices-configurations/:deviceId/edit-filters/:filterId', 
        name: 'EditConfigurationFilterView',
        component: EditConfigurationFilterView
      },
      { 
        path: '/a/components', 
        name: 'ComponentsView',
        component: ComponentsView
      },
      { 
        path: '/a/components/create-component', 
        name: 'CreateComponentView',
        component: CreateComponentView
      },
      { 
        path: '/a/components/edit-component/:componentId', 
        name: 'EditComponentView',
        component: EditComponentView
      }
    ] 
  }
]

export default routes